import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Modal, Box, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { ORDERS, SUPPORT } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
import CommentIcon from '@mui/icons-material/Comment';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import CloseIcon from '@mui/icons-material/Close';
import AppTooltip from "src/components/common/AppTooltip";
import ReactStars from "react-rating-stars-component";

const _ = require('lodash');

const FeedBackRating = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [showImage, setShowImage] = useState();
   const [filterName, setFilterName] = useState('');
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loading, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const [openModal, setOpenModal] = useState(false);
   const [modelTitle, setmodelTitle] = useState("");
   const [disable, setDisable] = useState(false);
   const [rowData, setRowData] = useState();

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'user_name', label: 'Customer Name', alignRight: false },
      { id: 'rating', label: 'Rating', alignRight: false },
      { id: 'comment', label: 'Comment', alignRight: false },
      { id: 'comment', label: 'Reply', alignRight: false },
      { id: 'createdAt', label: 'Date & Time', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getFeedBack(page, filterName) {
      const response = await axiosPrivate.get(SUPPORT.getFeedback, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: feedbackList, refetch } = useQuery(['feedbackList', page, filterName], () => getFeedBack(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (feedbackList) {
         setTableData(feedbackList.data);
         setRowsPerPage(feedbackList?.metadata.length != 0 ? feedbackList?.metadata[0].limit : 10);
      }
      if (feedbackList?.metadata.length != 0 && feedbackList?.metadata[0].hasMoreData == true) {
         getFeedBack(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [feedbackList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getFeedBack(page, filterName)
      refetch();
   };

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteOrder = async () => {
      const response = await axiosPrivate.delete(ORDERS.deleteOrder + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Order delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const completedSchema = Yup.object().shape({
      reply: Yup.string()
         .min(2, "reply can set of between 2 and 50 characters!")
         .max(50, "reply can set of between 2 and 50 characters!")
         .required("reply is required")
   });

   const formik = useFormik({
      initialValues: {
         reply: "",
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            reply: values.reply,
         };
         await replyToUser(informationObj);
         resetForm();
         setSubmitting(false);
      },
   });

   const { mutateAsync: replyToUser } = useMutation(
      async (data) => {
         return await axiosPrivate.put(SUPPORT.replyFeedback + rowData?._id, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar(data.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               }
            });
         },
      }
   );

   const handleOpenModalAdd = (row) => {
      setRowData(row)
      setFieldValue('name', "")
      // setId('')
      setmodelTitle('Reply')
      setDisable(false);
      setOpenModal(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched } = formik;

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">FeedBack</h4>
            <Paper component="form" className='dashboard_searchbox col-lg-4'>
               <IconButton>
                  <SearchIcon />
               </IconButton>
               <InputBase
                  fullWidth
                  sx={{ flex: 1 }}
                  placeholder="search ..."
                  onChange={(e) => handleFilterByName(e)}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
               />
            </Paper>
         </div>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions className='m-auto'>
               <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                  cancel
               </Button>
               <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                  delete
               </Button>
            </DialogActions>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={feedbackList?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers?.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell align="left"> {row?.user_data?.firstname} </TableCell>
                                 <TableCell align="left">
                                    <>
                                       <ReactStars
                                          count={5}
                                          edit={false}
                                          value={row?.rating}
                                          isHalf={true}
                                          size={24}
                                          activeColor="#ffd700"
                                       />
                                    </>
                                 </TableCell>
                                 <TableCell align="left"> {row?.comment} </TableCell>
                                 <TableCell align="left"> {row?.reply ?? '-'} </TableCell>
                                 <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       <AppTooltip title="Reply" placement="bottom">
                                          {
                                             row.reply ?
                                                <Button title="Reply" variant="text" className="user_list_row_btn" onClick={() => handleOpenModalAdd(row)} disabled><CommentIcon /></Button> :
                                                <Button title="Reply" variant="text" className="user_list_row_btn" onClick={() => handleOpenModalAdd(row)}><CommentIcon /></Button>
                                          }
                                       </AppTooltip>
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={feedbackList?.metadata.length != 0 ? feedbackList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2" sx={{ minWidth: '450px' }}>
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        {/* <div className="col-12">
                              <div className="form-group mb-3">
                                 <TextField label='Reply' name='reply' autoComplete='off' fullWidth variant='outlined'
                                    {...getFieldProps("reply")}
                                    error={Boolean(touched.reply && errors.reply)}
                                    helperText={touched.reply && errors.reply}
                                 />
                              </div>
                           </div> */}
                        <div className="col">
                           <div className="form-group mb-4">
                              <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '5.5rem' } }} label='Reply' multiline name='reply' autoComplete='off' fullWidth
                                 {...getFieldProps("reply")}
                                 error={Boolean(touched.reply && errors.reply)}
                                 helperText={touched.reply && errors.reply}
                              />
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <Button
                              type="submit"
                              fullWidth
                              variant="contained"
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                           >
                              submit
                           </Button>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default FeedBackRating